import { FaChartBar, FaSignOutAlt, FaUsers } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ExitsWrapper from './Exits';
import ServicesWrapper from './Services/index';
import GeneralResultsWrapper from './GeneralResults';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Resultados Gerais',
        path: '/governanceroom/dashboardsiasus/services/general-results',
        icon: <FaChartBar className="icon" />
    },
    {
        title: 'Atendimentos',
        path: '/governanceroom/dashboardsiasus/services/services',
        icon: <FaUsers className="icon" />
    },
    {
        title: 'Saídas',
        path: '/governanceroom/dashboardsiasus/services/outs',
        icon: <FaSignOutAlt className="icon" />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsiasus/services/general-results':
        'Resultados Gerais',
    '/governanceroom/dashboardsiasus/services/services': 'Atendimentos',
    '/governanceroom/dashboardsiasus/services/outs': 'Saídas'
};

export const Services = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsiasus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route path="services" element={<ServicesWrapper />} />
                        <Route
                            path="general-results"
                            element={<GeneralResultsWrapper />}
                        />
                        <Route path="outs" element={<ExitsWrapper />} />
                        <Route
                            path="/"
                            element={<Navigate to="general-results" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
